import { Vue } from "@/utils";

export default {
  setUserMicVolume: function(state, {userId, volume}) {
    let roomUser = this.getters['user/getRoomUser'](userId);
    if (!roomUser) {
      const rtspUser = this.getters['user/getMixerChannelRtspUser'](userId);
      if (!rtspUser) {
        return;
      }
      if (rtspUser) {
        roomUser = rtspUser;
      }
    }
    if (!roomUser) {
      return;
    }

    let isSpeaking = volume > 0;
    [
      { key: 'micVolume', val: volume },
      { key: 'isSpeaking', val: isSpeaking }
    ].forEach(obj => {
      Vue.set(roomUser, obj.key, obj.val);
    });
  },
  setUserSpeakData: function(state, {userSpeakData}) {
    let total = 0;
    let list = this.getters['user/roomUserList'].filter(ru => {
      return this.getters["user/isParticipantRole"](ru);
    });
    list.forEach(roomUser => {
      let data = userSpeakData.users[roomUser.userId];
      if(data){
        let time = data.speakTimeSeconds;
        Vue.set(roomUser, 'speakTimeSeconds', time);

        total += time;
      }else{
        roomUser.speakTimeSeconds = 0;
        roomUser.speakTimePercent = 0;
      }
    });

    list.sort((a,b) => b.speakTimeSeconds-a.speakTimeSeconds);

    let len = list.length;
    list.forEach((roomUser, i) => {
      let time = roomUser.speakTimeSeconds;
      let speakTimePercent = 0;
      if(time){
        speakTimePercent = parseFloat(
          (time / total * 100).toFixed(2)
        );
      }
      Vue.set(roomUser, 'speakTimePercent', speakTimePercent);
    })
  },
  UPDATE_ATTENDANCE_LIST: function(state, list) {
    state.attendanceList = list;
  },
  SET_USER_VIDEO_QUALITY: function(state, userVideoQuality){
    state.userVideoQuality = userVideoQuality
  },
  SET_ALL_USER_LAYOUT_OUT: function(state, userId){
    let roomUserList = this.getters['user/roomUserList'];
    roomUserList?.forEach(roomUser => {
      if(!roomUser.layoutSeqNum) {
        Vue.set(roomUser, 'layoutSeqNum');
      }
      roomUser.layoutSeqNum = -1;
    })
  },
  SET_USER_LAYOUT_IN: function(state, {userId, seqNum}){
    let roomUser = this.getters['user/getRoomUser'](userId);
    if(!roomUser){
      return;
    }
    if(!roomUser.layoutSeqNum) {
      Vue.set(roomUser, 'layoutSeqNum');
    }
    roomUser.layoutSeqNum = seqNum;
  },
  SET_MIXER_RTSP_USER: function (state, data) {
    if (!state.mixerRtspUserList.length) {
      state.mixerRtspUserList.push(data)
    } else {
      state.mixerRtspUserList.filter(u => {
        if (!u) {
          return
        }
        if (u.userId !== data.userId) {
          state.mixerRtspUserList.push(data)
        } else {
          Object.assign(u, data)
        }
      });
    }
  }
}
